import { useTranslation } from 'react-i18next';
import { FloatingKpiCard } from './FloatingKpiCard';

// KPI card keys for i18n lookup
const KPI_CARD_KEYS = [
  { key: 'lessAdmin', position: 'top-[8%] left-[15%]' },
  { key: 'oneOverview', position: 'top-[25%] right-[5%]' },
  { key: 'profitPerVehicle', position: 'bottom-[30%] left-[8%]' },
  { key: 'startFree', position: 'bottom-[10%] right-[8%]' },
] as const;

export function SignupMediaPanel() {
  const { t } = useTranslation('common');

  return (
    <div className="relative w-full h-full min-h-[500px] lg:min-h-screen overflow-hidden">
      {/* Background image placeholder */}
      {/* TODO: Replace with actual garage/dealer image asset */}
      <div
        className="absolute inset-0 bg-gradient-to-br from-primary/20 via-primary/10 to-background"
        aria-hidden="true"
      >
        {/* Decorative pattern overlay */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />

        {/* Gradient orbs for visual interest */}
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/20 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-48 h-48 bg-primary/15 rounded-full blur-3xl" />
      </div>

      {/* Floating KPI cards */}
      {KPI_CARD_KEYS.map((card, index) => (
        <div
          key={card.key}
          className={`absolute ${card.position} motion-reduce:animate-none`}
          style={{ animationDelay: `${index * 0.5}s` }}
        >
          <FloatingKpiCard
            title={t(`auth.signUp.hero.kpiCards.${card.key}.title`)}
            subtitle={t(`auth.signUp.hero.kpiCards.${card.key}.subtitle`)}
          />
        </div>
      ))}
    </div>
  );
}
